<template>
    <span
        class="vue-anchor-title cursor-pointer"
        :class="[anchorHoverBehavior === 'add' ? 'hover-add-underline' : 'hover-remove-underline']"
        @click.prevent="openModalMethod()"
        v-if="anchorPicture === false"
    >
        {{ anchorTitle }}
    </span>
    <a v-else @click.prevent="openModalMethod()" class="cursor-pointer">
        <img :srcset="`${smallPhotoJpg} 1x, ${regularPhotoJpg} 2x`" :alt="smallPhotoAlt" style="width: 50px" />
    </a>
</template>

<script>
export default {
    props: {
        anchorTitle: {
            default: 'Empty',
            type: String,
        },
        anchorHoverBehavior: {
            default: 'add',
        },
        modalType: {
            default: 'Empty',
            type: String,
        },
        modalId: {
            default: 0,
        },
        modalCloseButton: {
            default: false,
            type: Boolean,
        },
        modalContent: {
            default: 'false',
            type: String,
        },
        anchorPicture: {
            default: false,
            type: Boolean,
        },
        smallPhotoJpg: {
            default: 'Empty',
            type: String,
        },
        regularPhotoJpg: {
            default: 'Empty',
            type: String,
        },
        smallPhotoAlt: {
            default: 'Empty',
            type: String,
        },
        user: {},
        previousModalName: {
            default: 'Empty',
            type: String,
        },
        previousModalId: {
            default: 'Empty',
            type: String,
        },
    },
    data() {
        return {
            openModal: false,
        };
    },
    methods: {
        openModalMethod() {
            if (this.user) {
                this.$store.commit('auth/SET_USER', this.user);
            }
            this.$store.commit('store-modals/SET_TOOGLE_MODAL', !this.openModal);
            this.$store.commit('store-modals/SET_MODAL_TYPE', this.modalType);
            this.$store.commit('store-modals/SET_MODAL_ID', this.modalId);
            this.$store.commit('store-modals/SET_MODAL_CLOSE_BUTTON', this.modalCloseButton);
            this.$store.commit('store-modals/SET_MODAL_CONTENT', this.modalContent);
            this.$store.commit('store-modals/SET_PREVIOUS_MODAL_NAME', this.previousModalName);
            if (this.previousModalId !== 'Empty') {
                this.$store.commit('store-modals/SET_PREVIOUS_MODAL_ID', this.previousModalId);
            }
        },
    },
};
</script>
